import React from 'react';
import type { FeatureData } from '@sy/ssr-types';
import { Translation } from '~/components/Translation';
import { competitorImages } from '~/templates/LandingV3/StreamYardVsCompetitorTemplate/assets/imageImports';
import type { CompetitorType } from '../../../../types';
import {
	CardWrapper,
	Card,
	FeatureImage,
	FeatureImageImg,
	FeatureText,
	Title,
	Subtitle,
	LogoContainer,
} from './FeatureCard.styled';

interface FeatureCardProps {
	isCompetitor?: boolean;
	competitor: CompetitorType;
	feature: FeatureData;
	logo?: React.ReactNode;
}

// Get image dynamically based on competitor and image name
const getImageSrc = (competitor: CompetitorType, imageName: string): string => {
	const images = competitorImages[competitor];
	if (!images) {
		return '';
	}

	// Type assertion needed because TypeScript doesn't know the exact keys
	return images[imageName as keyof typeof images] || '';
};

const FeatureCard: React.FC<FeatureCardProps> = ({
	isCompetitor = false,
	competitor,
	feature,
	logo,
}) => {
	const imageSrc = getImageSrc(competitor, feature.imageName);

	return (
		<CardWrapper>
			<Card isCompetitor={isCompetitor}>
				<FeatureImage isCompetitor={isCompetitor}>
					{imageSrc && (
						<FeatureImageImg
							src={imageSrc}
							alt={`Feature: ${feature.imageName}`}
						/>
					)}
				</FeatureImage>
				<FeatureText>
					<Title variant="h5">
						<Translation tid={feature.titleKey} />
					</Title>
					<Subtitle variant="body">
						<Translation tid={feature.descriptionKey} />
					</Subtitle>
				</FeatureText>
			</Card>
			{logo && <LogoContainer>{logo}</LogoContainer>}
		</CardWrapper>
	);
};

export default FeatureCard;
